/**
 * Lightweight loader: always uses icon_loading.png with CSS spin.
 * (Frame cycling removed — was heavy and often skipped on slow devices.)
 */
const LoadingAnimation = ({ size = 'md', text = '' }) => {
  const sizeClasses = {
    sm: 'w-6 h-6',
    md: 'w-16 h-16 md:w-20 md:h-20',
    lg: 'w-24 h-24 md:w-32 md:h-32',
    xl: 'w-32 h-32 md:w-40 md:h-40',
  }

  return (
    <div className="flex flex-col items-center justify-center gap-3 md:gap-4">
      <img
        src="/assets/images/ui_elements/icon_loading.png"
        alt=""
        className={`${sizeClasses[size]} object-contain animate-spin`}
      />
      {text && (
        <div className="text-sm md:text-base lg:text-lg text-gray-600 text-center">
          {text}
        </div>
      )}
    </div>
  )
}

export default LoadingAnimation
